import { useQuery } from "@tanstack/react-query";
import type { OrderPriceByDepartmentResponse } from "../ordersApi";
import { getOrderPriceByDepartment } from "../ordersApi";

export const orderPriceByDepartmentQueryKey = (orderId: string | undefined) => ["orders", orderId, "priceByDepartment"];

export function useOrderPriceByDepartment(orderId: string | undefined) {
  return useQuery<OrderPriceByDepartmentResponse>({
    queryKey: orderPriceByDepartmentQueryKey(orderId),
    queryFn: ({ signal }) => getOrderPriceByDepartment(orderId!, signal),
    enabled: !!orderId,
  });
}
